export default __webpack_public_path__ + "static/media/text-type.318c2f63.svg";